




































































































































import Vue from 'vue'
import Button from '@/components/shared/atoms/Button/Button'
import Modal from '@/components/shared/atoms/Modal'
import SupportContentContainer from '@/containers/Support/Content'
import LinkButton from '@/components/shared/atoms/Button/LinkButton'
import { Payment, Shipment } from '@/entities/Cart'
import { PAYMENT_CODE, SHIPMENT_CODE, TAX_RATE } from '@/const'

interface IData {
  showSchoolModal: boolean
  showFaqModal: boolean
  FAQContentId: number | null
}

export default Vue.extend({
  components: {
    Button,
    Modal,
    LinkButton,
    SupportContentContainer
  },
  data(): IData {
    return {
      showSchoolModal: false,
      showFaqModal: false,
      FAQContentId: null
    }
  },
  computed: {
    getTaxRate(): number {
      return TAX_RATE * 100
    }
  },
  methods: {
    openFAQModal(id: number) {
      this.FAQContentId = id
      this.showFaqModal = true
    },
    getPaymentFee(paymentCode: Payment['code']): string {
      return PAYMENT_CODE[paymentCode].fee
    },
    getShipmentFee(shipmentCode: Shipment['code']): string {
      return SHIPMENT_CODE[shipmentCode].fee
    }
  }
})
